import styled from 'styled-components';
import { Layout } from 'antd';
const LayoutMainContent = styled(Layout.Content) `
  margin-left: 200px;
  overflow: auto;
`;
export default LayoutMainContent;
